var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RemoteTable',{ref:"table",attrs:{"form":_vm.form,"table":_vm.table},scopedSlots:_vm._u([{key:"expand",fn:function(ref){
var row = ref.row;
return [_c('el-form',{staticClass:"table-expand",attrs:{"label-position":"left"}},[_c('el-form-item',{attrs:{"label":"部门名称"}},[_vm._v(_vm._s(_vm.$root.getCustomerName(row.code)))]),_c('el-form-item',{attrs:{"label":"推送时间"}},[_vm._v(_vm._s(row.pushTime))])],1)]}},{key:"default",fn:function(ref){
var row = ref.row;
var property = ref.property;
return [(property === 'code')?[_vm._v(" "+_vm._s(_vm.$root.getBusinessName(row.code))+" ")]:_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }